import React from "react";
import CashRegisterReceiptsGenericSkeleton from "./CashRegisterReceiptsGenericSkeleton";

function CashRegisterReceiptsDetailSkeleton() {
  return (
    <>
      <CashRegisterReceiptsGenericSkeleton />
    </>
  );
}

export default CashRegisterReceiptsDetailSkeleton;
